<template>
  <div>

    <div class="row">
      <div class="col-12 col-xl-9 m-auto">
        <div class="card">
          <div class="card-header">
            <h4 class="title">Search companies</h4>
          </div>
          <div class="card-body">

            <div class="row" v-if="loading">
              <div class="col-12 text-center font-weight-bold">
                <span class="text-danger d-block"><i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...</span>
              </div>
            </div>

            <div class="row">

              <div class="col-6 my-4">
                <label>Company name</label>
                <br>
                <el-input
                    v-model="companyToSearch"
                    type="text"
                    :disabled="loadingCompanies"
                ></el-input>
              </div>

              <div class="col-6 text-center my-4 ">
                <br>
                <n-button native-type="button" type="primary" class="d-block m-auto px-2"
                          v-on:click="searchCompany" :disabled="loading || loadingCompanies || saving">
                  <i class="now-ui-icons ui-1_zoom-bold"></i> {{ $t('common.search') }}
                </n-button>
                <p v-if="loadingCompanies">
                  <span class="text-danger d-block"><i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...</span>
                </p>
              </div>
            </div>



            <div class="row">
              <div class="col-12 text-center">
<!--                <el-table class="table-striped" :data="companies" border style="width: 100%" height="400" @selection-change="companySelection">-->
                <el-table class="table-striped" :data="companies" border style="width: 100%" height="400">

<!--                  <el-table-column type="selection" width="55"></el-table-column>-->

                  <el-table-column key="name" :min-width="120" prop="name" label="Name"></el-table-column>
                  <el-table-column key="url" :min-width="160" prop="url" label="URL"></el-table-column>

                  <el-table-column key="actions" :min-width="100" prop="id" :label="$t('common.actions')">
                    <template #default="scope">

                      <n-button v-if="!companiesSelectedIds.includes(scope.row.id)"
                                native-type="button" type="primary" class="btn btn-sm btn-icon"
                                :disabled="loading || saving"
                                v-on:click="addCompany(scope.row)">
                        <i class="now-ui-icons ui-1_simple-add"></i>
                      </n-button>
                      <n-button v-else
                                native-type="button" type="warning" class="btn btn-sm btn-icon"
                                :disabled="loading || saving"
                                v-on:click="removeCompany(scope.row)">
                        <i class="fa fa-trash" style="font-size: 14px"></i>
                      </n-button>

                    </template>
                  </el-table-column>

                  <template #empty="">
                    <span>{{ $t('common.no_data') }}</span>
                  </template>

                </el-table>
              </div>



<!--              <div class="col-12 text-center mt-3">-->
<!--                <p :class="companiesSelected.length === 0 ? 'text-danger' : 'text-success'">{{ companiesSelected.length }}<span v-if="companies.length > 0">/{{ companies.length }}</span> {{ $t('task.companies_selected') }}</p>-->
<!--              </div>-->
            </div>

          </div>
        </div>










        <div class="card mt-5">
          <div class="card-header">
            <h4 class="title">Start new Analysis</h4>
          </div>
          <div class="card-body">

            <div class="row">

              <div class="col-12 text-center">
                <p :class="companiesSelected.length === 0 ? 'text-danger' : 'text-success'">{{ companiesSelected.length }} {{ $t('task.companies_selected') }}</p>
              </div>

              <div class="col-12 text-center">
                <el-table class="table-striped" :data="companiesSelected" border style="width: 100%">
                  <el-table-column key="name" :min-width="120" prop="name" label="Name"></el-table-column>
                  <el-table-column key="url" :min-width="160" prop="url" label="URL"></el-table-column>
                  <el-table-column key="actions" :min-width="100" prop="id" :label="$t('common.actions')">
                    <template #default="scope">

                      <n-button v-if="companiesSelectedIds.includes(scope.row.id)"
                                native-type="button" type="warning" class="btn btn-sm btn-icon"
                                :disabled="loading || saving"
                                v-on:click="removeCompany(scope.row)">
                        <i class="fa fa-trash" style="font-size: 14px"></i>
                      </n-button>
                    </template>
                  </el-table-column>

                  <template #empty="">
                    <span> No company selected. </span>
                  </template>

                </el-table>
              </div>
            </div>


            <div class="row mt-5">
              <div class="col-12 col-md-6 col-xl-3 m-auto">
                <label>From:</label>
                <br>
                <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    value-format="DD/MM/YYYY"
                    :disabled-date="disabledDate"
                    class="mt-2">
                </el-date-picker>
              </div>

              <div class="col-12 col-md-6 col-xl-3 m-auto">
                <label>To:</label>
                <br>
                <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    value-format="DD/MM/YYYY"
                    :disabled-date="disabledDate"
                    class="mt-2">
                </el-date-picker>
              </div>

              <div class="col-12 col-md-6 col-xl-3 m-auto">
                <label class="pb-2">Max num. documents:</label>
                <br>
                <el-input
                    v-model="form.max_documents"
                    type="number"
                    min="1"
                    max="100000"
                >
                </el-input>
              </div>
            </div>



            <div class="row mt-3">
              <div class="col-12 col-md-6 col-xl-4 m-auto">
                <label>Filter countries:
<!--                  <n-button native-type="button" type="outline-primary" class="btn-icon btn-sm m-0 my-info-button"-->
<!--                            v-on:click="showInfoBox('Country filter', 'This filter will select a subset of news originating in the specified Countries. Some news originating in other countries will still be considered, if they are duplicates/republications of news originating in countries of the list.')">-->
<!--                    <font-awesome-icon icon="info"></font-awesome-icon>-->
<!--                  </n-button>-->
                </label>
                <el-select
                    v-model="form.countries"
                    multiple
                    filterable
                    size="large"
                    class="d-block"
                    placeholder="All"
                    clearable
                >
                  <el-option
                      v-for="item in countries"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
              </div>





              <div class="col-12 col-md-6 col-xl-4 m-auto">
                <label>Select company industries:</label>
                <el-select
                    v-model="form.industries"
                    multiple
                    filterable
                    size="large"
                    class="d-block"
                    placeholder=""
                    clearable
                >

                  <el-option-group
                      v-for="(group, index) in industries"
                      :key="index"
                      :label="index"
                  >
                    <el-option
                        v-for="item in group"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    />
                  </el-option-group>

                </el-select>
              </div>
            </div>



            <div class="row my-3">
              <div class="col-12 col-md-6 col-lg-4 col-xl-3 m-auto text-center pt-3">
                <n-button native-type="button" type="primary" class="d-block m-auto px-2"
                          v-on:click="startTask"
                          :disabled="companiesSelected.length === 0 || loading || loadingCompanies || saving">
                  {{ $t('task.start_task') }}
                </n-button>
                <p v-if="saving">
                  <span class="text-danger d-block"><i class="fa fa-spinner fa-spin"></i> {{ $t('common.saving') }}...</span>
                </p>

              </div>

            </div>


          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
    import axios from 'axios';
    import { ElSelect, ElOption, ElOptionGroup, ElInput, ElTable, ElTableColumn, ElMessage, ElDatePicker } from "element-plus";
    import VeeInput from "src/components/Inputs/VeeInput";
    import Swal from "sweetalert2";


    export default {
        name: "NewTask",
        components: {
            [ElSelect.name]: ElSelect,
            [ElOption.name]: ElOption,
            [ElOptionGroup.name]: ElOptionGroup,
            [ElInput.name]: ElInput,
            [ElTable.name]: ElTable,
            [ElTableColumn.name]: ElTableColumn,
            [ElDatePicker.name]: ElDatePicker,
            [VeeInput.name]: VeeInput,
        },
        data () {
          return {
            loading: false,
            saving: false,
            error: null,
            errorSearch: null,
            errorStart: null,
            companyToSearch: null,
            loadingCompanies: false,
            companies: [],
            countries: [],
            industries: {},
            companiesSelected: [],
            companiesSelectedIds: [],
            formEnabled: false,
            form: {
              startDate: new Date(),
              endDate: new Date(),
              max_documents: 10000,
              search_company: null,
              countries: [],
              industries: [],
            }
          }
        },
        methods: {
          showError(error) {
              this.error = "";
              if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
                  this.error = this.$i18n.t("error.login_expired");
                  this.$store.commit('logout');
                  this.$router.push('/login');
              }
              else if (error.response && error.response.data && error.response.data.violations &&
                  error.response.data.violations.length > 0) {
                  for (let i = 0; i < error.response.data.violations.length; i++)
                  {
                      let stringErr = error.response.data.violations[i].message;
                      if(stringErr.endsWith("."))
                          stringErr = stringErr.slice(0, -1);
                      this.error += this.$i18n.t(stringErr) + ". ";
                  }
              } else if(error.response && error.response.data && error.response.data.message)
              {
                  let stringErr = error.response.data.message;
                  if(stringErr.endsWith("."))
                      stringErr = stringErr.slice(0, -1);
                  this.error = this.$i18n.t("error." + stringErr);
              }
              else if (error.response && error.response.data && error.response.data['hydra:description'])
                  this.error = this.$i18n.t("error." + error.response.data['hydra:description']);
              else if (error.length > 0)
                  this.error = this.$i18n.t(error);
              else this.error = this.$i18n.t("error.try_again");
              ElMessage.error(this.error);
              console.log(error);
          },
          disabledDate(time) {
              return time.getTime() > (new Date());
          },
          formatDate(date, time = true) {
              var dateObj = new Date(date);
              if(time)
                  return dateObj.toLocaleString();
              else
                  return dateObj.toLocaleDateString();
          },
          companySelection(items) {
            this.companiesSelected = items;
          },
          addCompany(item) {
            this.companiesSelected.push(item);
            this.companiesSelectedIds.push(item.id);
          },
          removeCompany(item) {
            this.companiesSelected.splice(this.companiesSelected.findIndex(v => v.id === item.id), 1);
            this.companiesSelectedIds.splice(this.companiesSelectedIds.findIndex(v => v === item.id), 1);
          },
          searchCompany() {
            this.error = null;

            if (this.companyToSearch && this.companyToSearch.length > 2) {
                this.loadingCompanies = true;
                axios.get(process.env.VUE_APP_SERVER_BASE_URL + "search_companies/" + this.companyToSearch)
                    .then((response) => {
                      this.companies = response.data.companies;
                      // this.companiesSelected = [];
                      this.form.search_company = this.companyToSearch;
                    }).catch(error => {this.companies = []; this.showError(error);}).finally(() => {this.loadingCompanies = false;});
            } else {
              this.showError("new_task.error_at_least_3_chars");
              this.companies = [];
              // this.companiesSelected = [];
            }
          },
          showInfoBox(title, text) {
            Swal.fire({
              position: 'top-end',
              title: title,
              text: text,
              showConfirmButton: false,
              showCloseButton: true,
              customClass: {
                title: 'font-size-18',
              }
            });
          },
          startTask() {
            this.error = null;

            if (this.companiesSelected.length === 0) {
              this.showError("new_task.no_company_selected");
              return;
            }

            if(this.form.startDate == null) {
              this.showError("new_task.start_date_field_required");
              return;
            }

            if(this.form.endDate == null) {
              this.showError("new_task.end_date_field_required");
              return;
            }

            if(this.form.startDate > this.form.endDate) {
              this.showError("new_task.wrong_dates");
              return;
            }

            if(this.form.industries.length === 0) {
              this.showError("new_task.industry_field_required");
              return;
            }

            if(this.form.max_documents == null || this.form.max_documents < 1 || this.form.max_documents > 100000)
              this.form.max_documents = 10000;

            let data = {
              analysis_start_date: this.form.startDate.toDateString(),
              analysis_end_date: this.form.endDate.toDateString(),
              max_insights: this.form.max_documents,
              companies: this.companiesSelected,
              search_company: this.companyToSearch,
              countries: this.form.countries,
              industries: this.form.industries
            };

            this.saving = true;
            let config =  {data: data};
            config.method = "post";
            config.url = process.env.VUE_APP_SERVER_BASE_URL + 'new_task/';

            axios(config).then((response) => {
              Swal.fire({
                icon: 'success',
                title: this.$i18n.t("common.done") + "!",
                text: "New analysis successfully started",
                confirmButtonClass: "btn btn-info",
                confirmButtonText: "Go to My Analyses",
                buttonsStyling: false
              }).then((result) => {
                this.$router.push('/task/list');
              });
            }).catch(error => {this.showError(error);}).finally(() => {this.saving = false;});
          }
        },
        computed: {
        },
        beforeMount() {
          this.loading = true;

          axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_countries/")
              .then(response => {
                this.countries = response.data["countries"];
              }).catch(error => {this.showError(error);}).finally(() => {this.loading = false;});


          axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_company_industries/")
              .then(response => {
                for (var industry of response.data["industries"]) {
                  if (!this.industries[industry.category])
                    this.industries[industry.category] = [];
                  this.industries[industry.category].push({id: industry.id, name: industry.name});
                }
              }).catch(error => {this.showError(error);}).finally(() => {this.loading = false;});

          var start = new Date();
          start.setFullYear(start.getFullYear() -1 );
          start.setMonth(0);
          start.setDate(1);
          this.form.startDate = start;

          var end = new Date();
          end.setFullYear(end.getFullYear() -1 );
          end.setMonth(11);
          end.setDate(31);
          this.form.endDate = end;
        },
    }
</script>

<style>
.el-select__input {
  color: white;
}
</style>
